import { GridColDef } from "@mui/x-data-grid";

const permissionSetColumnDef: GridColDef[] = [
    { field: 'owner_type', headerName: 'Owner Type', width: 100 },
    { field: 'owner_name', headerName: 'Owner Name', width: 150 },
    { field: 'username', headerName: 'Username', width: 150 },
    { field: 'permission_name', headerName: 'Permission Name', width: 150 },
    { field: 'is_active', headerName: 'Permission Active Status', width: 200 },
    { field: 'license_count', headerName: 'License Count', width: 150 },
    { field: 'created_date', headerName: 'Created Date', width: 150 },
    { field: 'created_by', headerName: 'Created By', width: 150 },
    { field: 'updated_date', headerName: 'Updated Date', width: 150 },
    { field: 'updated_by', headerName: 'Updated By', width: 150 },
];

export default permissionSetColumnDef;